module.exports = __webpack_public_path__ + "img/02.af0187aa.jpg";